<template>
    <div >
        <Card title="保障信息">
            <Form :label-width="120" ref="form" class="mt15">
                <Row>
                    <Col span="12">
                        <FormItem label="保障期限：" class="w600">1个月</FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="保险起期：" class="w600">{{info.beginDate}}</FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="保险止期：" class="w600">{{info.endDate}}</FormItem>
                    </Col>
                    <Col span="12" v-if="type=='rider'">
                        <FormItem label="批改费用合计：" class="w600">{{info.premium}}元</FormItem>
                    </Col>
                    <Col span="12" v-else>
                        <FormItem label="保费合计：" class="w600">{{info.premium}}元</FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="保障方案：" class="w600">{{info.insurancePlanName}}</FormItem>
                    </Col>
                </Row> 
            </Form>
            <el-table class="mt10" ref="table" :data="tableData" border style="width: 100%">
                <el-table-column prop="name" label="姓名" show-overflow-tooltip width="180"></el-table-column>
                <el-table-column prop="idNo" label="身份证号" show-overflow-tooltip width="180"></el-table-column>
                <el-table-column prop="genderName" label="性别" show-overflow-tooltip width="180"></el-table-column>
                <el-table-column prop="age" label="年龄" width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="beginDate" label="保障起期" width="180"></el-table-column>
                <el-table-column prop="endDate" label="保障止期" width="180"></el-table-column>
                <el-table-column prop="premium" label="保费（元）" width="180" align="right"></el-table-column>
                <el-table-column v-if="type=='rider'" prop="operationName" label="批改类型" width="180"></el-table-column>
                <el-table-column v-if="type=='policy'||type=='rider'" prop="statusName" label="保障状态" width="100"></el-table-column>
                <el-table-column prop="remark" label="备注" show-overflow-tooltip width="180"></el-table-column>
            </el-table>
            <Row class="mt10" v-if="tableData.length>0">
                <Col :span="24" class="right">
                    <Page 
                        :total="pageinfo.total" 
                        :current="pageinfo.page" 
                        :page-size="pageinfo.size"
                        @on-change="handleCurrentChange"
                        show-total
                        @on-page-size-change="handleSizeChange"
                    />
                </Col>
            </Row>
        </Card>
    </div>
    </template>
    <script>
    export default {
        props:{
            info:{
                type: Object,
                default(){
                    return {}
                }
            },
            type:{
                type: String,
                default(){
                    return ''
                }
            },
        },
        data () {
            return {
                loading: false,
                params: {
                },
                status:' ',
                detailList: [],
                tableData:[],
                pageinfo: {
                    page: 1,
                    size: 10,
                    total: 0,
                }
            }
        },
        watch: {
            info: function(newVal,oldVal){
                this.detailList = newVal.users || [];
                this.pageinfo.total = this.detailList.length;
                this.pageinfo.page = 1; // 重置到第一页
                this.tableData = this.currentChangePage(this.pageinfo.size, this.pageinfo.page);
            }
        },
        methods:{
            /** 切换每页显示条数 */
            handleSizeChange(val) {
                this.pageinfo.page = 1;
                this.pageinfo.size = val;
                this.tableData = this.currentChangePage(val, this.pageinfo.page);
            },
            /** 切换分页 */
            handleCurrentChange(val) {
                this.pageinfo.page = val;
                this.tableData = this.currentChangePage(this.pageinfo.size, val);
            },
            // 分页方法
            currentChangePage(size, current) {
                const tablePush = [];
                let array = JSON.parse(JSON.stringify(this.detailList));
                array.forEach((item, index) => {
                    if (size * (current - 1) <= index && index <= size * current - 1) {
                    tablePush.push(item);
                    }
                });
                return tablePush;
            },
        }
    }
    </script>
    <style scoped>
        .content{
            padding:0 15px 15px;
        }
    </style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/customizedLineWork/common/supportPlans.vue